import React, { type FC } from 'react'

import { Capability, type CybusDetailedConnection, StatusType, Translation } from '../../../../domain'

import { ConnectIcon, DeleteIcon, DisconnectIcon } from '../../common'
import { DetailsActionButton } from '../../Details'
import { useAppUsecases } from '../../State'

export const HeaderActions: FC<{ resource: CybusDetailedConnection }> = ({ resource: { id, status } }) => {
    const { bulkDeleteConnectionsUsecase, bulkConnectConnectionsUsecase, bulkDisconnectConnectionsUsecase } = useAppUsecases()

    const disabled = status !== StatusType.CONNECTED && status !== StatusType.DISCONNECTED
    const statusTranslation =
        status === StatusType.CONNECTED ? Translation.DISCONNECT : status === StatusType.CONNECTING ? Translation.CONNECTING : Translation.CONNECT

    const handleConnectDisconnect =
        status === StatusType.CONNECTED
            ? () => bulkDisconnectConnectionsUsecase.selectConnections([id])
            : () => bulkConnectConnectionsUsecase.selectConnections([id])

    return (
        <>
            <DetailsActionButton
                data-testid="connection-action-button"
                disabled={disabled}
                text={statusTranslation}
                capabilities={[Capability.CONNECTIONS_MANAGE]}
                onClick={handleConnectDisconnect}
                startIcon={status === StatusType.CONNECTED ? <DisconnectIcon /> : <ConnectIcon />}
                showText
            />

            <DetailsActionButton
                data-testid="delete-connection-button"
                text={Translation.DELETE}
                capabilities={[Capability.CONNECTIONS_MANAGE]}
                onClick={() => bulkDeleteConnectionsUsecase.selectConnections([id])}
                startIcon={<DeleteIcon />}
                variant="dangerOutline"
            />
        </>
    )
}
